import { usePeriodOptions } from 'hooks/usePeriodOptions';
import { Dropdown } from 'semantic-ui-react';
import { PeriodName } from 'utils/periodDates';

interface PeriodNameDropdownProps {
  periodName: PeriodName;
  onChange: (periodName: PeriodName) => void;
}

export const PeriodNameDropdown = ({
  periodName,
  onChange,
}: PeriodNameDropdownProps) => {
  const { periodOptions } = usePeriodOptions();

  return (
    <Dropdown
      className="tw-ml-2"
      inline
      options={periodOptions}
      value={periodName}
      onChange={(event, { value }) => onChange(value as PeriodName)}
    />
  );
};
